var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404ErrorwithabrokenrobotRafiki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 928.87,
    height: 692.12,
    viewBox: "0 0 928.87 692.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oops_404_Error_with_a_broken_robot-rafiki",
    "data-name": "Oops! 404 Error with a broken robot-rafiki",
    transform: "translate(0 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1",
    transform: "translate(0 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 928.87,
    height: 0.464,
    transform: "translate(0 608.224)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 40.276,
    height: 0.464,
    transform: "translate(795.522 638.115)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 63.368,
    height: 0.464,
    transform: "translate(576.94 628.492)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 82.725,
    height: 0.464,
    transform: "translate(736.761 620.876)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 20.695,
    height: 0.464,
    transform: "translate(300.731 630.239)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 71.319,
    height: 0.464,
    transform: "translate(212.86 630.239)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 51.459,
    height: 0.464,
    transform: "translate(123.187 622.399)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M407.51,580.369H48.8A10.608,10.608,0,0,1,38.21,569.761V65.515A10.608,10.608,0,0,1,48.8,55H407.51a10.608,10.608,0,0,1,10.608,10.608V569.761A10.608,10.608,0,0,1,407.51,580.369ZM48.8,55.372A10.143,10.143,0,0,0,38.674,65.515V569.761A10.143,10.143,0,0,0,48.8,579.9H407.51a10.162,10.162,0,0,0,10.143-10.143V65.515A10.162,10.162,0,0,0,407.51,55.372Z",
    transform: "translate(32.774 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M623.838,580.369H265.108A10.626,10.626,0,0,1,254.5,569.761V65.515A10.626,10.626,0,0,1,265.108,55h358.73a10.608,10.608,0,0,1,10.571,10.515V569.761A10.608,10.608,0,0,1,623.838,580.369Zm-358.73-525a10.162,10.162,0,0,0-10.143,10.143V569.761A10.162,10.162,0,0,0,265.108,579.9h358.73a10.162,10.162,0,0,0,10.143-10.143V65.515a10.162,10.162,0,0,0-10.143-10.143Z",
    transform: "translate(218.295 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M365.763,284.047l.836-24.411-14.973-4.9a147.139,147.139,0,0,0-4.013-24.522l12.707-9.289L351.7,198l-15.716,1.263a145.222,145.222,0,0,0-13-21.085l8.137-13.58L314.4,146.741l-14.045,7.189a151.926,151.926,0,0,0-20.175-14.565l2.266-15.605L260.15,113.655l-10.218,11.964a149.843,149.843,0,0,0-24.151-5.573l-3.716-15.289-24.485-.836-4.83,14.992a149.509,149.509,0,0,0-24.5,3.994l-9.437-12.633-22.925,8.564,1.263,15.716a148.862,148.862,0,0,0-21.085,13.134l-13.673-8.323-17.927,16.72L91.653,170.2a144.176,144.176,0,0,0-14.49,20.138L61.576,188,51.4,210.294l12.038,10.2a145.9,145.9,0,0,0-5.573,24.151l-15.475,3.883-.836,24.411,15.048,4.9a143.789,143.789,0,0,0,3.994,24.5l-12.707,9.289,8.638,22.943,15.716-1.263a143.046,143.046,0,0,0,13,21.085l-8.156,13.58,16.72,17.853,14.045-7.189a149.994,149.994,0,0,0,20.138,14.546l-2.341,15.586L147.943,418.9l10.273-11.964a151.822,151.822,0,0,0,24.151,5.666l3.715,15.289,24.485.836,4.83-14.992a151.409,151.409,0,0,0,24.522-3.994l9.289,12.633,22.924-8.564-1.189-15.716a155,155,0,0,0,21.085-13.134l13.506,8.137,17.927-16.72-7.189-14.119a143.753,143.753,0,0,0,14.49-20.138l15.586,2.341,10.18-22.293L344.492,311.95a143.529,143.529,0,0,0,5.666-24.151ZM200.814,363.131a96.9,96.9,0,1,1,100.114-93.5A96.9,96.9,0,0,1,200.814,363.131Z",
    transform: "translate(35.639 -13.039)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M483.064,203.464l6.149-5.74-2.434-4.849a51.274,51.274,0,0,0,5-6.948l5.387.8,3.474-7.691-4.124-3.511a49.855,49.855,0,0,0,1.951-8.341l5.295-1.319.26-8.434-5.165-1.672a52.614,52.614,0,0,0-1.375-8.471l4.366-3.251-2.972-7.9-5.406.427a52.485,52.485,0,0,0-4.514-7.282l2.805-4.644-5.778-6.168-4.83,2.471a52.458,52.458,0,0,0-6.948-5l.78-5.387-7.672-3.511-3.53,4.143a51.7,51.7,0,0,0-8.341-1.858l-1.319-5.276-8.434-.316-1.691,5.2a50.162,50.162,0,0,0-8.434,1.375l-3.232-4.366-7.914,2.954.446,5.425a49.383,49.383,0,0,0-7.282,4.514l-4.681-2.805-6.168,5.74,2.4,4.737a49.411,49.411,0,0,0-5.016,6.948l-5.369-.8-3.493,7.691,4.143,3.53a49.225,49.225,0,0,0-1.858,8.323l-5.313,1.319-.26,8.434,5.183,1.672A50.614,50.614,0,0,0,398.5,172.1l-4.384,3.232,2.972,7.9,5.425-.409a52.485,52.485,0,0,0,4.514,7.282l-2.805,4.644L410,200.918l4.83-2.471a50.815,50.815,0,0,0,6.948,5l-.8,5.369,7.691,3.511,3.53-4.124a53.76,53.76,0,0,0,8.341,1.858l1.319,5.276,8.434.316,1.691-5.2a49.9,49.9,0,0,0,8.434-1.375l3.232,4.366,7.914-2.954-.427-5.425a49.585,49.585,0,0,0,7.264-4.514Zm-43.88-35.539a10.992,10.992,0,1,1-.074,0Z",
    transform: "translate(336.2 -13.194)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M435.941,342.861l-19.209-13.283h0A104.5,104.5,0,0,0,409,309.57l4.923-19.32L386.06,260.414,366.443,264a104.593,104.593,0,0,0-19.451-9.084h0l-11.927-20.082L294.2,233.44l-13.264,19.209h0a105.017,105.017,0,0,0-19.989,7.71l-19.321-4.923L211.786,283.3l3.585,19.581h0a104.457,104.457,0,0,0-9.066,19.488L186.223,334.3l-1.393,40.87,19.228,13.264a101.708,101.708,0,0,0,7.71,20.1h0l-4.979,19.153,27.866,29.835,19.488-3.567a106.233,106.233,0,0,0,19.581,9.1h0L285.631,483.1l40.87,1.412L339.747,465.3a106.036,106.036,0,0,0,20.175-7.728h0l19.209,4.9,29.854-27.866L405.4,415.034a102.925,102.925,0,0,0,9.066-19.506h0L434.548,383.6Zm-127.162,62.03a47.567,47.567,0,1,0-.019,0Z",
    transform: "translate(158.536 98.055)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M396.911,325.127h-.13l-32.176-1.1a3.864,3.864,0,0,1-3.233-1.858L352.7,307.59a88.876,88.876,0,0,1-13.524-6.279l-13.877,2.4a3.9,3.9,0,0,1-3.567-1.189L299.751,279a3.9,3.9,0,0,1-.929-3.715l3.511-13.766a84.432,84.432,0,0,1-5.313-13.877l-13.989-9.66a3.9,3.9,0,0,1-1.691-3.363l1.1-32.176a3.975,3.975,0,0,1,1.858-3.232l14.62-8.676a84.192,84.192,0,0,1,6.261-13.469l-2.564-13.989a3.92,3.92,0,0,1,1.189-3.585l23.519-21.958a3.92,3.92,0,0,1,3.715-.947l13.822,3.53a85.147,85.147,0,0,1,13.84-5.332l9.66-13.989a3.715,3.715,0,0,1,3.363-1.691l32.157,1.115a3.92,3.92,0,0,1,3.251,1.858l8.676,14.6a86.218,86.218,0,0,1,13.413,6.279l14.044-2.582a3.883,3.883,0,0,1,3.567,1.189l21.977,23.519a3.939,3.939,0,0,1,.929,3.715l-3.53,13.8a86.56,86.56,0,0,1,5.35,13.84l13.97,9.66a3.9,3.9,0,0,1,1.691,3.363l-1.1,32.157a4.013,4.013,0,0,1-1.858,3.251l-14.62,8.676A86.4,86.4,0,0,1,463.381,267l2.564,14.007a3.883,3.883,0,0,1-1.189,3.567L441.088,306.55a3.9,3.9,0,0,1-3.716.929l-13.747-3.511a88.217,88.217,0,0,1-13.914,5.332l-9.567,13.97A3.957,3.957,0,0,1,396.911,325.127Zm-29.891-8.861,27.866.947,9.289-13.357a3.715,3.715,0,0,1,2.211-1.56,81.445,81.445,0,0,0,15.141-5.815h0a4.013,4.013,0,0,1,2.712-.279l13,3.325,20.435-19.042-2.341-13.431a3.882,3.882,0,0,1,.483-2.731,77.243,77.243,0,0,0,6.781-14.546,3.957,3.957,0,0,1,1.746-2.192l13.989-8.286.947-27.866-13.376-9.289a3.919,3.919,0,0,1-1.5-1.988c0-.093,0-.2,0-.316a79.9,79.9,0,0,0-5.8-14.862,3.919,3.919,0,0,1-.3-2.749l3.344-13.153-19.042-20.435-13.357,2.452a3.957,3.957,0,0,1-2.712-.483,78.586,78.586,0,0,0-14.565-6.818,4.233,4.233,0,0,1-.836-.372,3.9,3.9,0,0,1-1.3-1.338l-8.378-14.026-27.866-.966-9.289,13.394a4.013,4.013,0,0,1-2.3,1.579,79.194,79.194,0,0,0-14.973,5.778,3.864,3.864,0,0,1-2.731.3L331.147,144.8l-20.435,19.042,2.452,13.32a4.05,4.05,0,0,1-.353,2.471l-.186.316a77.2,77.2,0,0,0-6.781,14.6,3.938,3.938,0,0,1-1.709,2.081l-13.989,8.3L289.2,232.8l13.394,9.289a3.9,3.9,0,0,1,1.56,2.192,77.135,77.135,0,0,0,5.778,15.085,4.719,4.719,0,0,1,.316.855,4.16,4.16,0,0,1,0,1.858l-3.344,13,19.042,20.435,13.264-2.434a3.9,3.9,0,0,1,2.694.483,80.364,80.364,0,0,0,14.658,6.818,3.716,3.716,0,0,1,2.174,1.728Zm46.035-176.132ZM384.241,281.024h-2.062a58.575,58.575,0,1,1,2.062,0Zm0-109.774a51.181,51.181,0,1,0,1.765,0Z",
    transform: "translate(241.316 -0.022)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M391.245,115.527l-13.339-3.567L374.34,98.622l5.22-5.2,5.5,11.388,11.407,5.517Z",
    transform: "translate(321.087 -22.046)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M387.937,109.175a6.213,6.213,0,1,0-8.787-8.787l6.632-9.958,8.88,4.5,1.951,9.289Z",
    transform: "translate(325.212 -24.61)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M376.58,98.512l9.772-9.772,13.3,3.548,3.585,13.32-9.772,9.772-13.32-3.585Zm17.741,7.988a4.4,4.4,0,1,1,0-.037Z",
    transform: "translate(323.008 -26.06)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M91.515,302.191l7.152-1.932,1.913-7.152-2.787-2.787-2.954,6.112-6.131,2.954Z",
    transform: "translate(76.09 146.844)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M92.2,298.77a3.344,3.344,0,0,1,4.719-4.719l-3.548-5.332L88.48,291.1l-1.04,5.016Z",
    transform: "translate(75.001 145.471)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M100.479,293.039,95.24,287.8l-7.152,1.858L86.23,296.81l5.146,5.295,7.152-1.858Zm-9.512,4.291a3.344,3.344,0,1,1,4.568-.151,3.344,3.344,0,0,1-4.568.151Z",
    transform: "translate(73.963 144.682)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M76.878,88.748l5.945,5.945a3.976,3.976,0,0,0,5.573,0h0a3.994,3.994,0,0,0,0-5.573L82.47,83.193a3.994,3.994,0,0,0-5.573,0h0A3.976,3.976,0,0,0,76.878,88.748Z",
    transform: "translate(64.979 -31.789)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M76.871,77.85A8.267,8.267,0,1,1,71.3,88.588,8.527,8.527,0,0,1,76.871,77.85Z",
    transform: "translate(60.806 -35.661)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 2.545,
    height: 18.763,
    transform: "translate(132.073 54.327) rotate(-109.76)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1",
    transform: "translate(104.238 705.061)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 360.197,
    cy: 21.03,
    rx: 360.197,
    ry: 21.03,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--oops--inject-1",
    transform: "translate(160.137 111.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M87.166,135.8c-1.858-8.193-1.04-15.066,2.489-20.677s9.289-9.289,17.481-11.146,15.271-1.115,20.807,2.341,9.289,9.289,11.146,17.277a31.86,31.86,0,0,1,.316,15.085,21.624,21.624,0,0,1-6.558,10.7,28.851,28.851,0,0,1-13.227,6.279,32.789,32.789,0,0,1-14.639.5,21.772,21.772,0,0,1-10.961-6.5A29.11,29.11,0,0,1,87.166,135.8Zm15.494-3.455q1.728,7.58,5.295,10.255a10.942,10.942,0,0,0,15.419-3.418c1.338-2.582,1.356-6.688.093-12.28q-1.616-7.078-5.22-9.7a9.958,9.958,0,0,0-8.471-1.5,9.66,9.66,0,0,0-6.781,5.016C101.619,123.446,101.489,127.162,102.66,132.345Z",
    transform: "translate(-86.2 -70.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M118.867,128.712a18.578,18.578,0,0,1,2.508-14.973,21.476,21.476,0,0,1,13.914-8.824q10.9-2.471,17.909,2.582a20.249,20.249,0,0,1,4.9,26.51q-4.347,6.632-14.156,8.843a21.977,21.977,0,0,1-15.159-1.226A18.3,18.3,0,0,1,118.867,128.712Zm13.952-3.214a11.3,11.3,0,0,0,3.585,6.744,6.651,6.651,0,0,0,9.9-2.211,11.759,11.759,0,0,0,.26-7.8,11.146,11.146,0,0,0-3.548-6.576,6.186,6.186,0,0,0-5.35-1.208,6.484,6.484,0,0,0-4.5,3.474,11.146,11.146,0,0,0-.353,7.58Z",
    transform: "translate(-58.695 -69.673)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M153.838,154.922,142.45,104.763l13-2.972,1.226,5.369a17.649,17.649,0,0,1,3.92-5.7,14.583,14.583,0,0,1,6.372-3.14,13.394,13.394,0,0,1,12.521,3.01,23.8,23.8,0,0,1,7.115,12.874c1.375,6.038.966,10.979-1.189,14.862a14.621,14.621,0,0,1-9.9,7.264,15.921,15.921,0,0,1-6.112.241,14.417,14.417,0,0,1-5.462-2.174l3.938,17.333Zm6.706-35.037a9.828,9.828,0,0,0,3.27,5.982,5.926,5.926,0,0,0,5.053,1.04,5.239,5.239,0,0,0,3.715-2.917,11.147,11.147,0,0,0,0-7.171,10.422,10.422,0,0,0-3.177-6.093,5.406,5.406,0,0,0-4.644-1.115,5.8,5.8,0,0,0-3.975,3.1,10.626,10.626,0,0,0-.242,7.171Z",
    transform: "translate(-37.952 -75.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M170.489,125.3l13.524-4.44a6.967,6.967,0,0,0,3.2,2.972,8.713,8.713,0,0,0,8.416-2.044,2.768,2.768,0,0,0,.687-2.489,2.582,2.582,0,0,0-2.1-1.988,28.942,28.942,0,0,0-6.316,0,62.475,62.475,0,0,1-10.589,0,10.923,10.923,0,0,1-5.573-2.545,10.236,10.236,0,0,1-2.582-12.057A12.54,12.54,0,0,1,174,97.525a31.173,31.173,0,0,1,9.53-3.511,34.331,34.331,0,0,1,9.809-1.189,12.837,12.837,0,0,1,5.87,1.858,16.459,16.459,0,0,1,4.719,4.867l-13,4.291a4.663,4.663,0,0,0-2.285-2.174,7.152,7.152,0,0,0-4.217-.186,5.722,5.722,0,0,0-3.251,1.616,2.508,2.508,0,0,0-.613,2.266,2.229,2.229,0,0,0,1.858,1.709,22.961,22.961,0,0,0,6.242-.13,41.649,41.649,0,0,1,10.812-.149,11.685,11.685,0,0,1,6.093,2.805,10.143,10.143,0,0,1,3.084,5.295,11.481,11.481,0,0,1-.5,6.558,13.153,13.153,0,0,1-4.9,6.075,29.278,29.278,0,0,1-10.738,4.291q-9.939,2.266-14.862.39a13.134,13.134,0,0,1-7.152-6.911Z",
    transform: "translate(-15.869 -79.356)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M193.85,85.57H209.1v11.7L206.3,120.811H196.86l-3.01-23.5Zm.743,38.79h14.23v12.6h-14.23Z",
    transform: "translate(6.136 -85.57)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-404--inject-1",
    transform: "translate(132.178 137.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M153.606,192.919h-.334c-8.36-3.251-13.357-6.409-15.958-10.218a9.548,9.548,0,0,1-6-.817,12.075,12.075,0,0,1-5.183-4.867,4.719,4.719,0,0,1-4.5.687,11.407,11.407,0,0,1-5.573-4.477,4.143,4.143,0,0,1-2.9.8c-5.573-.446-13-11.444-13.543-23.147a.966.966,0,0,1,.892-.985.929.929,0,0,1,.966.892c.52,11.146,7.635,21.048,11.852,21.383a2.341,2.341,0,0,0,1.728-.5,22.813,22.813,0,0,1-1.858-17.5c1.6-5.573,3.01-7.765,4.719-7.431,3.2.8,2.768,13,1.077,20.974a11.406,11.406,0,0,1-1.56,4.05,10.032,10.032,0,0,0,4.719,4.106,2.935,2.935,0,0,0,3.1-.65c-1.449-3.585-1.858-8.49.223-14.732,2.6-8.23,3.715-8.453,4.291-8.6a1.226,1.226,0,0,1,1.189.409c1.728,1.951-.334,14.732-2.489,21.048a9.288,9.288,0,0,1-1.04,2.155,10.329,10.329,0,0,0,4.626,4.644,8.193,8.193,0,0,0,4.236.8c-.167-.353-.316-.706-.464-1.077-1.468-3.994-.743-8.583,2.211-14.082,1.951-3.623,3.548-5.332,5.034-5.332h0a2.062,2.062,0,0,1,1.858,1.226c1.616,2.991.446,12.856-2.749,17.76a7.431,7.431,0,0,1-3.01,2.6c2.489,3.27,7.227,6.149,14.862,9.084a.91.91,0,0,1,.539,1.189.948.948,0,0,1-.966.613Zm-10.552-30.6s-1.059,0-3.4,4.366c-2.694,4.979-3.381,9.084-2.1,12.54a9.4,9.4,0,0,0,.557,1.245,5.351,5.351,0,0,0,2.452-2.044c2.6-3.976,3.846-12.15,2.88-15.345C143.314,162.433,143.054,162.322,143.054,162.322ZM129.716,154.5a43.341,43.341,0,0,0-2.489,6.558,21.141,21.141,0,0,0-.706,12.168l.167-.483a60.915,60.915,0,0,0,3.084-18.243Zm-12.224-5.852c-.316.279-1.226,1.449-2.508,5.982a20.881,20.881,0,0,0,1.338,15.308,11.482,11.482,0,0,0,.836-2.6c1.988-9.122,1.43-17.37.39-18.689Z",
    transform: "translate(-46.73 -58.756)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M170.823,235.007a16.719,16.719,0,0,1-8.471-2.211.948.948,0,0,1-.334-1.282.91.91,0,0,1,1.263-.316c6.632,3.883,15.2,1.17,16.961-1.672a1.635,1.635,0,0,0,.279-1.245,15.085,15.085,0,0,1-9.53-2.712c-4.737-2.954-5.109-3.846-5.072-4.551a1.133,1.133,0,0,1,.632-.966c1.858-.929,10.236,2.917,13.729,5.22a6.746,6.746,0,0,1,1.152.966,6.6,6.6,0,0,0,3.53-2.118,5.332,5.332,0,0,0,1.1-2.1h-.371c-2.972.3-5.945-.985-9.122-3.92-2.192-2.006-3.028-3.4-2.749-4.5a1.672,1.672,0,0,1,1.338-1.208c2.564-.65,8.917,2.062,11.5,4.9a4.978,4.978,0,0,1,1.189,2.192c2.434-1.133,5-3.715,8.025-7.933a.929.929,0,0,1,1.3-.223.947.947,0,0,1,.223,1.3c-3.511,4.9-6.446,7.691-9.382,8.824a6.855,6.855,0,0,1-1.616,3.715,8.545,8.545,0,0,1-4.05,2.619,3.418,3.418,0,0,1-.52,2.582C180.261,233.038,175.765,235.007,170.823,235.007Zm-1.653-12.893c.632.464,1.523,1.078,2.805,1.858a14.862,14.862,0,0,0,6.688,2.452A45.828,45.828,0,0,0,169.17,222.115Zm6.484-7.9a8.044,8.044,0,0,0,2.174,2.582c2.749,2.545,5.257,3.715,7.672,3.418h.594a3.362,3.362,0,0,0-.817-1.542C182.676,215.743,176.954,213.922,175.653,214.219Z",
    transform: "translate(6.684 -3.462)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M273.254,286.437l-28.944,5.257L218.023,148.24l-55.844,10.143L71.15,320.007l9.772,53.336,116.759-21.2,7.988,43.62,55.844-10.18-7.988-43.62,28.944-5.257Zm-146.483,26.7,48.3-84.657,13.469,73.455Z",
    transform: "translate(-71.15 -57.437)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M398.417,180.43a109.309,109.309,0,0,0-5.945-26.417,86.03,86.03,0,0,0-13-22.646,75,75,0,0,0-23.593-19.246q-14.862-8.156-39.421-11.351-50.995-6.651-79.474,18.094T199.453,213.61a258.836,258.836,0,0,0-1.858,52.648q1.858,24.151,8.88,38.883a81.258,81.258,0,0,0,27.216,33.031q17.593,12.354,48.3,16.33,54.58,7.115,80.942-20.974T397.86,238.6a240.536,240.536,0,0,0,.557-58.166Z",
    transform: "translate(36.814 -99.362)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M289.284,325.971c-4.477-.149-9.289-.557-14.137-1.189-17.017-2.211-30.17-6.521-39.124-12.8a60.674,60.674,0,0,1-20.435-24.894l-.093-.2c-3.567-7.431-5.908-18.113-6.929-31.582a238.165,238.165,0,0,1,1.709-48.487c6.632-51.5,20.324-72.991,30.634-81.945,12.038-10.441,28.293-15.159,49.657-14.416,4.384.149,9.029.539,13.8,1.152,13.71,1.858,24.578,4.83,32.269,9.029a55.343,55.343,0,0,1,17.3,13.914,65.484,65.484,0,0,1,9.939,17.221,88.762,88.762,0,0,1,4.756,21.457,220.453,220.453,0,0,1-.539,53.354c-5.146,40.016-15.1,68.142-29.575,83.6-10.738,11.444-26.844,16.72-49.249,15.865Z",
    transform: "translate(46.261 -89.911)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M314.441,167.281l.242-7.041-4.329-1.412a42.388,42.388,0,0,0-1.152-7.059l3.715-2.712-2.489-6.614-4.533.372a42.392,42.392,0,0,0-3.715-6.075l2.341-3.92-4.83-5.146-4.05,2.081a43.044,43.044,0,0,0-5.8-4.2l.65-4.5-6.428-2.917-2.935,3.455a43.206,43.206,0,0,0-6.967-1.635l-1.1-4.4-7.059-.242-1.393,4.31a43.729,43.729,0,0,0-7.059,1.152l-2.731-3.715-6.614,2.471.372,4.533a42.62,42.62,0,0,0-6.075,3.715l-3.9-2.359-5.165,4.812,2.081,4.068a40.466,40.466,0,0,0-4.18,5.815l-4.5-.687-2.935,6.428,3.474,2.935a39.815,39.815,0,0,0-1.635,6.985l-4.421,1.115-.242,7.022,4.329,1.412a41.985,41.985,0,0,0,1.152,7.078l-3.715,2.694,2.489,6.614,4.533-.372a39.963,39.963,0,0,0,3.715,6.075l-2.359,3.92,4.83,5.146,4.05-2.062a42.918,42.918,0,0,0,5.8,4.18l-.669,4.5,6.428,2.917,2.954-3.437a42.948,42.948,0,0,0,6.985,1.616l1.1,4.421,7.041.242,1.393-4.329a41.984,41.984,0,0,0,7.078-1.152l2.694,3.715,6.614-2.471-.353-4.514a46.236,46.236,0,0,0,6.075-3.715l3.9,2.341,5.165-4.812-2.062-4.068a40.159,40.159,0,0,0,4.161-5.8l4.5.669,2.935-6.428-3.455-2.935A41.3,41.3,0,0,0,310,168.4Zm-47.558,22.794a27.866,27.866,0,1,1,20.035-7.48,27.866,27.866,0,0,1-20.035,7.48Z",
    transform: "translate(57.46 -85.673)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M316.163,230.222l.52-4.756-2.861-1.152a29.718,29.718,0,0,0-.409-4.83L316,217.831l-1.319-4.589h-3.084a27.523,27.523,0,0,0-2.211-4.291l1.746-2.527-2.972-3.715-2.842,1.189a29.85,29.85,0,0,0-3.716-3.121l.687-3.01-4.18-2.3-2.192,2.211a29.48,29.48,0,0,0-4.607-1.468l-.52-3.028-4.737-.539-1.17,2.861a27.585,27.585,0,0,0-4.812.446l-1.653-2.638-4.589,1.356v3.084a27.677,27.677,0,0,0-4.291,2.229l-2.527-1.858-3.715,2.972,1.189,2.842a29.964,29.964,0,0,0-3.1,3.715l-3.01-.669-2.285,4.18,2.192,2.174a27.87,27.87,0,0,0-1.468,4.626l-3.047.5-.5,4.737,2.842,1.189a27.367,27.367,0,0,0,.427,4.793l-2.619,1.653,1.338,4.589h3.1a28.264,28.264,0,0,0,2.229,4.273l-1.858,2.527,2.972,3.715,2.879-1.208a27.031,27.031,0,0,0,3.715,3.1l-.65,3.065,4.18,2.285,2.174-2.174a29.952,29.952,0,0,0,4.607,1.43l.539,3.047,4.737.52,1.152-2.842a30.129,30.129,0,0,0,4.9-.409l1.653,2.619,4.57-1.338v-3.084a30.563,30.563,0,0,0,4.31-2.229l2.489,1.858,3.715-2.991-1.208-2.842a30.242,30.242,0,0,0,3.14-3.715l2.991.669,2.3-4.18-2.192-2.155a30.6,30.6,0,0,0,1.43-4.607Zm-23.909-1.858a8.286,8.286,0,1,1-3.288-11.239,8.286,8.286,0,0,1,3.288,11.239Z",
    transform: "translate(85.053 -19.353)",
    fill: "#1f5d7a",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M334.665,184.206l-5.573-3.827h0a30.82,30.82,0,0,0-2.229-5.759l1.412-5.573-8.025-8.6-5.573,1.04a31.582,31.582,0,0,0-5.573-2.619h0l-3.437-5.8-11.759-.39-3.827,5.573h0a29.578,29.578,0,0,0-5.759,2.229l-5.573-1.43-8.6,8.044,1.04,5.573h0a29.13,29.13,0,0,0-2.619,5.573l-5.778,3.437-.409,11.759,5.573,3.827a29.929,29.929,0,0,0,2.229,5.8h0l-1.412,5.573,8.025,8.6,5.573-1.022a31.874,31.874,0,0,0,5.573,2.619h0l3.418,5.778,11.778.409,3.808-5.573a30.861,30.861,0,0,0,5.815-2.229h0l5.573,1.412,8.6-8.025-1.022-5.573a31.021,31.021,0,0,0,2.619-5.573h0l5.778-3.437Zm-36.653,17.871a13.227,13.227,0,1,1,13.673-12.763,13.227,13.227,0,0,1-13.673,12.763Z",
    transform: "translate(92.876 -53.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M331.414,131.351l.966-2.322h0a12.444,12.444,0,0,0,1.858-1.282h2.155l2.527-3.715-.817-1.988a11.486,11.486,0,0,0,.743-2.062h0l1.858-1.709-.78-4.366-2.341-.966h0a11.8,11.8,0,0,0-1.282-1.858v-2.155l-3.623-2.527-2.006.836h0a10.311,10.311,0,0,0-2.266-.52L326.7,104.86l-4.347.78-.985,2.341a12.078,12.078,0,0,0-1.951,1.263h-2.136l-2.526,3.715.817,1.988a11.479,11.479,0,0,0-.52,2.266h0l-1.858,1.728.78,4.347,2.341.966a10.642,10.642,0,0,0,1.263,1.858h0v2.136l3.715,2.527,1.988-.817a11.944,11.944,0,0,0,2.285.5h0l1.709,1.858Zm-9.289-12.038a4.979,4.979,0,1,1,5.778,4.013,4.979,4.979,0,0,1-5.778-4.013Z",
    transform: "translate(136.458 -94.645)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M296.27,117.336l-1.43-1.208a36.969,36.969,0,0,1,11.147-9.289l.873,1.635A35.056,35.056,0,0,0,296.27,117.336Z",
    transform: "translate(120.718 -92.947)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M303.925,109.289l-.725-1.709a44.437,44.437,0,0,1,21.81-3.493l-.186,1.858a42.338,42.338,0,0,0-20.9,3.344Z",
    transform: "translate(127.889 -95.471)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M302.4,119.681l-1.523-1.04a31.1,31.1,0,0,1,18.336-11.871l.353,1.858A29.2,29.2,0,0,0,302.4,119.681Z",
    transform: "translate(125.899 -93.007)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M253.55,245.109a.966.966,0,0,1-.669-.3L249,240.8a32.494,32.494,0,0,1-5.852-1.078l-6.075,2.675a.91.91,0,0,1-.873,0l-10.18-6.744a.91.91,0,0,1-.409-.8V228.24a31.953,31.953,0,0,1-3.27-4.979l-5.22-2.006a.929.929,0,0,1-.576-.687L214.129,208.6a.929.929,0,0,1,.26-.855l4.013-3.883a34.886,34.886,0,0,1,1.077-5.852L216.8,191.94a.91.91,0,0,1,0-.873l6.744-10.18a.873.873,0,0,1,.8-.409l6.614.093a30.689,30.689,0,0,1,4.979-3.27l2.025-5.22a.91.91,0,0,1,.669-.576L250.6,169.09a.91.91,0,0,1,.855.26l3.883,4.013a32.989,32.989,0,0,1,5.87,1.078l6.056-2.675a.947.947,0,0,1,.892,0l10.162,6.744a1,1,0,0,1,.427.8l-.111,6.614a32.067,32.067,0,0,1,3.288,4.979l5.2,2.025a.91.91,0,0,1,.576.669l2.434,11.964a.966.966,0,0,1-.26.855l-4.031,3.9a33.437,33.437,0,0,1-1.077,5.833l2.675,6.075a.947.947,0,0,1,0,.892L280.785,233.2a.948.948,0,0,1-.78.409l-6.632-.093a34.144,34.144,0,0,1-4.96,3.27l-2.025,5.22a.91.91,0,0,1-.687.576l-11.964,2.527Zm-10.459-7.431a.67.67,0,0,1,.26,0,30.952,30.952,0,0,0,6.149,1.133,1.04,1.04,0,0,1,.594.279l3.715,3.9,10.961-2.211,1.969-5.09a1.022,1.022,0,0,1,.446-.483,29.817,29.817,0,0,0,5.22-3.437.873.873,0,0,1,.613-.2l6.446.093,6.168-9.289-2.6-5.908a.929.929,0,0,1,0-.632,32.495,32.495,0,0,0,1.133-6.149.947.947,0,0,1,.279-.594l3.9-3.715-2.211-10.961-5.072-1.969a.91.91,0,0,1-.5-.446,30.528,30.528,0,0,0-3.437-5.22.966.966,0,0,1-.2-.595v-6.465l-9.289-6.168-5.889,2.6a.966.966,0,0,1-.65,0,31.582,31.582,0,0,0-6.168-1.133,1.04,1.04,0,0,1-.594-.279l-3.716-3.9-10.961,2.229L237.7,178.23a.947.947,0,0,1-.427.5,29.608,29.608,0,0,0-5.239,3.437.8.8,0,0,1-.595.2L225,182.28l-6.186,9.289,2.6,5.908a.929.929,0,0,1,0,.8,31.826,31.826,0,0,0-1.077,6,.929.929,0,0,1-.279.594l-3.9,3.715,2.229,10.961,5.053,1.969a1.022,1.022,0,0,1,.52.483,30.131,30.131,0,0,0,3.418,5.183.892.892,0,0,1,.2.594v6.465l9.289,6.168,5.908-2.6a.967.967,0,0,1,.316-.13Zm9.122-6.019a24.745,24.745,0,0,1-20.6-38.418h0a24.764,24.764,0,1,1,20.6,38.418Zm-19.042-37.4a22.795,22.795,0,1,0,14.526-9.825,22.887,22.887,0,0,0-14.526,9.825Z",
    transform: "translate(51.472 -39.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M522.678,303.709l-29.167-3.938L512.794,155.22l-56.252-7.58L320.091,273.26,312.92,327,430.5,342.87l-5.87,43.973,56.252,7.58,5.87-43.954,29.167,3.938ZM375.136,283.794l72.006-65.634-9.883,74.012Z",
    transform: "translate(136.226 -57.951)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M394.591,390.326h-.242a.929.929,0,0,1-.743-1.077l43.471-237.679a.947.947,0,0,1,1.077-.743.929.929,0,0,1,.743,1.077L395.52,389.564A.948.948,0,0,1,394.591,390.326Z",
    transform: "translate(205.422 -55.229)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M416.237,154.1a1.524,1.524,0,1,1-1.468-1.579A1.524,1.524,0,0,1,416.237,154.1Z",
    transform: "translate(222.231 -53.766)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M412.906,171.4a1.523,1.523,0,1,1-.406-1.094A1.523,1.523,0,0,1,412.906,171.4Z",
    transform: "translate(219.376 -38.927)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M409.577,188.73A1.523,1.523,0,0,1,408,190.2a1.5,1.5,0,0,1-1.468-1.56,1.523,1.523,0,0,1,1.579-1.486,1.542,1.542,0,0,1,1.468,1.579Z",
    transform: "translate(216.519 -24.062)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M403.012,206.781a1.523,1.523,0,1,1-.7-1.458A1.523,1.523,0,0,1,403.012,206.781Z",
    transform: "translate(210.897 -8.674)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M402.906,223.3a1.5,1.5,0,0,1-1.579,1.468,1.523,1.523,0,1,1,1.579-1.468Z",
    transform: "translate(210.798 5.591)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M399.577,240.591a1.523,1.523,0,1,1-1.468-1.56A1.523,1.523,0,0,1,399.577,240.591Z",
    transform: "translate(207.942 20.437)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M396.247,257.9a1.542,1.542,0,0,1-1.579,1.486,1.529,1.529,0,1,1,1.579-1.486Z",
    transform: "translate(205.085 35.272)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M392.906,275.21a1.523,1.523,0,1,1-1.468-1.579,1.5,1.5,0,0,1,1.468,1.579Z",
    transform: "translate(202.221 50.115)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M401.213,207.764a.91.91,0,0,1-.892-.725.929.929,0,0,1,.706-1.115l4.607-.985a.931.931,0,1,1,.39,1.821l-4.607.985Z",
    transform: "translate(211.173 -8.822)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M412.331,197.24a158.015,158.015,0,0,0-5.573,17.388c-1.393,6.558-1.468,21.234-1.468,21.234",
    transform: "translate(215.455 -15.407)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M405.719,237.25h0a.966.966,0,0,1-.929-.947c0-.594.111-14.862,1.5-21.4a156.458,156.458,0,0,1,5.573-17.537.929.929,0,1,1,1.728.669,156.751,156.751,0,0,0-5.573,17.258c-1.356,6.391-1.449,20.881-1.468,21.03A.929.929,0,0,1,405.719,237.25Z",
    transform: "translate(215.027 -15.866)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    transform: "translate(211.615 410.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M222.45,354.776c2.582-41.613-2.155-117.279,76.074-107.247,83.84,10.719,59.856,108.771,59.856,108.771Z",
    transform: "translate(-20.811 -246.622)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 34.145,
    cy: 34.145,
    r: 34.145,
    transform: "translate(221.48 14.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M270.167,254.835c-16.181-2.749-33.439,9.159-35.167,21.234l64.111,5.908C296.844,268.21,282.985,257.027,270.167,254.835Z",
    transform: "translate(-10.046 -239.921)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M274.9,280.264c-.464,8.936-5.332,15.939-10.868,15.642s-9.66-7.747-9.289-16.72,5.332-15.939,10.868-15.642S275.343,271.347,274.9,280.264Z",
    transform: "translate(6.866 -232.115)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M268.133,325.626a36,36,0,1,1,36-36A36,36,0,0,1,268.133,325.626Zm0-68.272a32.288,32.288,0,1,0,32.288,32.269,32.288,32.288,0,0,0-32.288-32.269Z",
    transform: "translate(-12.508 -240.62)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M291,328.841h-.223a.91.91,0,0,1-.687-1.115c0-.242,5.982-25.432-.167-50.9a.955.955,0,0,1,1.858-.446c6.261,26.008.223,51.534.167,51.775A.929.929,0,0,1,291,328.841Z",
    transform: "translate(37.04 -221.727)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M292.256,276.279a.966.966,0,0,1-.855-.539,64.89,64.89,0,0,0-8.806-14.23.931.931,0,1,1,1.449-1.17,67.753,67.753,0,0,1,9.047,14.62.91.91,0,0,1-.446,1.226A1,1,0,0,1,292.256,276.279Z",
    transform: "translate(30.601 -235.153)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M133.218,443.16h-.687a9.292,9.292,0,1,1,.52-18.577h.167c5.369,0,18.28-6.521,45.292-49.1a9.289,9.289,0,0,1,13.952-2.025,385.4,385.4,0,0,0,69,47.335,9.289,9.289,0,1,1-8.4,16.552,395.23,395.23,0,0,1-64.649-42.988C165.765,428.446,148.971,443.16,133.218,443.16Z",
    transform: "translate(-105.686 -139.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M167.991,419.269h-.8a5.573,5.573,0,0,1-4.719-6.3c1.319-9.289-.316-43.9-12.038-70.836A5.573,5.573,0,0,1,152.4,335.3c25.451-17.333,79.66-19.413,81.964-19.488a5.576,5.576,0,1,1,.372,11.146c-.5,0-47.893,1.858-72.229,15.234,10.366,26.826,12.726,60.247,11,72.34a5.573,5.573,0,0,1-5.517,4.737Z",
    transform: "translate(-82.981 -187.278)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M184.737,370.5c-3.715-8.75-20.435-7.765-30.225-.26-5.239,3.994-12.335,16.051-13,20.435a6.576,6.576,0,0,0,7.431,7.877c6.409-.557,15.2-9.865,15.2-9.865-5.852,5.74,1.709,9.79,13,1.486C183.307,385.544,188.88,380.286,184.737,370.5Z",
    transform: "translate(-90.364 -145.713)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M337.141,333.02a.6.6,0,0,1-.26,0,.91.91,0,0,1-.632-1.152c2.471-8.62,5.164-13.877,8.713-16.72a9.624,9.624,0,0,1,.3-6.056,11.982,11.982,0,0,1,4.384-5.573,4.719,4.719,0,0,1-1.1-4.421,11.481,11.481,0,0,1,3.976-5.87,4.161,4.161,0,0,1-1.059-2.805c0-5.573,10.236-13.97,21.847-15.568a.938.938,0,0,1,.26,1.858c-11.035,1.5-20.286,9.493-20.249,13.71a2.434,2.434,0,0,0,.669,1.691,22.739,22.739,0,0,1,17.24-3.474c5.7,1.1,8.025,2.3,7.765,4.031-.52,3.251-12.651,3.938-20.788,2.972a11.481,11.481,0,0,1-4.18-1.208,9.994,9.994,0,0,0-3.716,5.072,2.917,2.917,0,0,0,.91,3.047c3.455-1.858,8.3-2.527,14.713-1.115,8.416,1.858,8.731,2.879,8.936,3.493a1.244,1.244,0,0,1-.316,1.245c-1.765,1.858-14.676.985-21.16-.613a9.118,9.118,0,0,1-2.248-.836,10.125,10.125,0,0,0-4.2,5.034,7.858,7.858,0,0,0-.427,4.273,10.722,10.722,0,0,1,1.022-.539c3.846-1.858,8.49-1.523,14.23.929,3.716,1.616,5.573,3.065,5.759,4.533a2.081,2.081,0,0,1-1.059,1.858c-2.842,1.858-12.763,1.6-17.927-1.152a7.431,7.431,0,0,1-2.861-2.768c-3.028,2.787-5.48,7.747-7.71,15.531a.948.948,0,0,1-.836.594Zm10.069-17.333a5.574,5.574,0,0,0,2.266,2.266c4.2,2.229,12.447,2.731,15.531,1.486.632-.26.725-.464.725-.464s-.093-1.04-4.644-2.991c-5.2-2.229-9.289-2.545-12.688-.966a10.748,10.748,0,0,0-1.189.669Zm6.2-12.205.464.13a61.472,61.472,0,0,0,18.466,1.393,40.315,40.315,0,0,0-6.762-1.858,21.142,21.142,0,0,0-12.168.334Zm2.341-10.44a11,11,0,0,0,2.657.594c9.289,1.1,17.444-.186,18.577-1.356-.316-.279-1.56-1.077-6.168-1.951A20.9,20.9,0,0,0,355.756,293.042Z",
    transform: "translate(76.764 -222.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M254.608,409.833c1.226-.39.817-1.579-.557-1.579H228.9c-47.893-5.072-81.35,1.728-60.265,3.325s-1.486,1.263-16.887,7.1,114.53,7.3,126.326,0C288.92,411.951,237.628,415.276,254.608,409.833Z",
    transform: "translate(-82.544 -109.57)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M408.706,513.565,189.864,506.3,180.78,294.11l258.43,5.778Z",
    transform: "translate(-56.553 -205.89)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M230.977,509.308a.929.929,0,0,1-.929-.855l-17.537-213.12a.947.947,0,0,1,.855-1,.966.966,0,0,1,1,.855L232,508.305a.929.929,0,0,1-.855,1Z",
    transform: "translate(-29.338 -205.702)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M303.47,510.9l58.816-8.954,18.522-197.311-46.834-7.412Z",
    transform: "translate(48.683 -203.222)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M303.47,510.9l58.816-8.954,18.522-197.311-46.834-7.412Z",
    transform: "translate(48.683 -203.222)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M198.227,455.508,192.84,329.423a22.794,22.794,0,0,1,23.277-23.761l163.593,3.716a22.794,22.794,0,0,1,22.051,26.008L383.63,462.344a22.794,22.794,0,0,1-23.277,19.6L220.3,477.3A22.794,22.794,0,0,1,198.227,455.508Z",
    transform: "translate(-46.227 -195.985)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M205.7,326.49l25.3.8-.2,6.521-15.847-.5-.149,4.867,14.695.464-.2,6.242L214.6,344.4l-.186,6.038,16.292.52-.223,6.911-25.767-.817Z",
    transform: "translate(-36.019 -178.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M221.4,357.58l.966-30.56,15.754.5a22.7,22.7,0,0,1,6.669.966,7.078,7.078,0,0,1,3.715,2.9,8.62,8.62,0,0,1-3.047,12.242,11.444,11.444,0,0,1-3.362,1.115,9.508,9.508,0,0,1,2.434,1.189,10.237,10.237,0,0,1,1.449,1.672,11.948,11.948,0,0,1,1.263,1.858l4.291,9.01-10.663-.353-4.756-9.493a7.32,7.32,0,0,0-1.635-2.415,4.124,4.124,0,0,0-2.285-.78h-.836l-.39,12.391Zm10.069-17.871,3.976.13a16.048,16.048,0,0,0,2.508-.353,2.508,2.508,0,0,0,1.579-.91,2.917,2.917,0,0,0,.65-1.746,2.861,2.861,0,0,0-.873-2.3,5.758,5.758,0,0,0-3.493-.91l-4.161-.13Z",
    transform: "translate(-21.711 -177.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M239.28,358.11l.966-30.56,15.735.5a22.589,22.589,0,0,1,6.669.966,7,7,0,0,1,3.715,2.9,8.945,8.945,0,0,1-3.028,12.242,11.649,11.649,0,0,1-3.363,1.115,9.289,9.289,0,0,1,2.415,1.189,8.989,8.989,0,0,1,1.468,1.653,12.767,12.767,0,0,1,1.263,1.858l4.291,8.991-10.663-.334-4.756-9.493a7.431,7.431,0,0,0-1.635-2.415,3.864,3.864,0,0,0-2.3-.78h-.817l-.409,12.41Zm10.05-17.871,3.994.111a13.4,13.4,0,0,0,2.508-.334,2.433,2.433,0,0,0,1.561-.91,2.712,2.712,0,0,0,.65-1.746,2.824,2.824,0,0,0-.855-2.3,5.574,5.574,0,0,0-3.511-.91l-4.143-.13Z",
    transform: "translate(-6.375 -177.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M256.345,343.49a14.472,14.472,0,0,1,16.274-15.326,15.977,15.977,0,0,1,11.63,4.477,15.456,15.456,0,0,1,3.715,11.611,18.968,18.968,0,0,1-2.081,8.731,13,13,0,0,1-5.387,5.164,17.129,17.129,0,0,1-8.564,1.635,19.656,19.656,0,0,1-8.508-1.858,13,13,0,0,1-5.313-5.387,17.11,17.11,0,0,1-1.765-9.047Zm9.437.334a10.329,10.329,0,0,0,1.5,6.706,6.539,6.539,0,0,0,9.4.353,11.388,11.388,0,0,0,1.858-7.059A9.6,9.6,0,0,0,277,337.453a5.982,5.982,0,0,0-4.533-2.062,5.759,5.759,0,0,0-4.663,1.858,10.329,10.329,0,0,0-2.025,6.576Z",
    transform: "translate(8.216 -176.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M275.91,359.328l.966-30.578,15.735.5a23.24,23.24,0,0,1,6.669.966,7.189,7.189,0,0,1,3.715,2.9,8.341,8.341,0,0,1,1.263,5,8.211,8.211,0,0,1-4.291,7.264,12.276,12.276,0,0,1-3.362,1.1,9.288,9.288,0,0,1,2.415,1.208,8.992,8.992,0,0,1,1.468,1.653,11.955,11.955,0,0,1,1.263,1.858l4.291,9.01-10.663-.334-4.756-9.512a7.262,7.262,0,0,0-1.635-2.4,4.013,4.013,0,0,0-2.3-.8h-.817l-.409,12.41Zm10.05-17.89,3.994.13a13.4,13.4,0,0,0,2.508-.334,2.508,2.508,0,0,0,1.56-.91,2.749,2.749,0,0,0,.65-1.858,2.786,2.786,0,0,0-.855-2.285,5.573,5.573,0,0,0-3.511-.91l-4.143-.13Z",
    transform: "translate(25.044 -176.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M352.622,386.888a2.452,2.452,0,0,1-1.858-.8l-15.9-17.407L317.7,384.362a2.434,2.434,0,0,1-3.437-.149l-15.9-17.407-17.166,15.679a2.434,2.434,0,0,1-3.437-.149L261.835,364.93l-17.147,15.679a2.47,2.47,0,0,1-1.858.632,2.508,2.508,0,0,1-1.691-.8l-15.9-17.388L208.09,378.714a2.452,2.452,0,0,1-3.455-.149,2.415,2.415,0,0,1,.167-3.437L223.751,357.8a2.452,2.452,0,0,1,3.455.149l15.9,17.407,17.147-15.679a2.545,2.545,0,0,1,1.765-.632,2.471,2.471,0,0,1,1.691.8l15.9,17.407,17.166-15.679a2.415,2.415,0,0,1,3.437.148l15.9,17.407,17.166-15.679a2.434,2.434,0,0,1,3.437.149l17.76,19.283a2.452,2.452,0,0,1-1.858,4.087Z",
    transform: "translate(-36.639 -151.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M135.906,443.4l-11.629-5.555L113.91,387.366l5.629-6.186Z",
    transform: "translate(-113.91 -131.206)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M133.307,443.4l15.438-9.029-13.227-41.576L116.94,381.18Z",
    transform: "translate(-111.311 -131.206)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M133.307,443.4l15.438-9.029-13.227-41.576L116.94,381.18Z",
    transform: "translate(-111.311 -131.206)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M266.766,441.941h-1.282a9.292,9.292,0,1,1,.5-18.577c14.3.464,44.586-8.323,61.9-25.117a9.288,9.288,0,0,1,3.715-2.229c29.334-8.806,40.239,8.973,40.685,9.734l-15.977,9.456a1.853,1.853,0,0,0,.2.334c-.167-.242-4.328-5.573-17.556-2.3C317.241,433.043,283.913,441.941,266.766,441.941Z",
    transform: "translate(8.346 -120.574)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M278.236,456.031l-33.83-2.118L241.75,391.53l45.459,1.691Z",
    transform: "translate(-4.256 -122.329)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M261.39,455.25l7.914-7.877,4.9-38.883-3.846-16.051Z",
    transform: "translate(12.59 -121.548)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M261.39,455.25l7.914-7.877,4.9-38.883-3.846-16.051Z",
    transform: "translate(12.59 -121.548)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M398.714,490.611a5.573,5.573,0,0,1-3.363-1.133c-19.32-14.676-45.422-40.74-55.435-65.875a4.9,4.9,0,0,1-.316-1.133c-4.886-29.055-9.549-90.193-9.753-92.776a5.589,5.589,0,0,1,11.147-.836c0,.613,4.774,62.346,9.53,91.159,9.995,24.448,37.155,49.546,51.608,60.581a5.573,5.573,0,0,1-3.381,10.013Z",
    transform: "translate(71.295 -180.521)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M388.552,422.384c-4.31,0-9.2-1.951-14.528-5.8a5.574,5.574,0,0,1,6.539-9.029c4.607,3.325,7.115,3.715,7.988,3.715a5.573,5.573,0,0,1,0,11.146Z",
    transform: "translate(107.224 -109.489)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M373.921,418.185c5.963-17.7,30.411-14.212,38.845-11.574a88.745,88.745,0,0,1,20.565,8.917c4.551,2.972,4.626,7.97-1.449,10.812-7.431,3.493-26.306.39-26.306.39,9.735,4.254,0,11.146-17.11,4.384C382.912,428.923,371.821,424.687,373.921,418.185Z",
    transform: "translate(108.888 -111.253)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M357.674,344.847C355.463,359.894,343,370.985,332.855,369.5s-10.552-14.862-8.341-29.984,6.223-26.008,16.367-24.522S359.885,329.855,357.674,344.847Z",
    transform: "translate(65.798 -188.094)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 1.523,
    cy: 1.523,
    r: 1.523,
    transform: "translate(176.764 93.7)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M219.617,304.483a1.523,1.523,0,1,1-1.523-1.523,1.523,1.523,0,0,1,1.523,1.523Z",
    transform: "translate(-25.854 -198.299)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M220.537,401.383a1.523,1.523,0,1,1-1.523-1.523,1.523,1.523,0,0,1,1.523,1.523Z",
    transform: "translate(-25.065 -115.184)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M228.047,407.293a1.523,1.523,0,1,1-1.523-1.523,1.523,1.523,0,0,1,1.523,1.523Z",
    transform: "translate(-18.624 -110.115)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--robot-parts--inject-1",
    transform: "translate(139.47 705.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M88.887,425.873a17.871,17.871,0,0,1-13.617-7.338.929.929,0,1,1,1.523-1.059c3.474,5.016,11.146,7.672,14.49,6.093a2.415,2.415,0,0,0,.873-.632,11.239,11.239,0,0,1-6.539-8.323c-.427-2.359-.762-5.573,1.17-5.982,2.675-.594,6.168,5.852,7.431,10.738a7.022,7.022,0,0,1,.242,2.489,7.913,7.913,0,0,0,3.307.26,3.6,3.6,0,0,0,2.564-1.375,10.887,10.887,0,0,1-4.291-7.784c-.706-5.09-.167-5.963.39-6.409a1.226,1.226,0,0,1,1.282-.13c1.988.836,4.384,8.044,4.849,12.131a4.942,4.942,0,0,1,0,1.282,7.262,7.262,0,0,0,2.508.483,7.969,7.969,0,0,0,4.477-1.17c-.26-.167-.5-.353-.743-.539-1.858-1.653-2.712-4.291-2.378-8.044.26-2.917.91-4.514,2.081-5.016a2.1,2.1,0,0,1,2.248.446,12.856,12.856,0,0,1,3.214,10.329,5.573,5.573,0,0,1-.947,2.136c3.418.594,8.211-.372,12.354-1.393a.955.955,0,1,1,.446,1.858c-5.034,1.245-10.459,2.266-14.286,1.152a10.571,10.571,0,0,1-6.5,2.155,8.973,8.973,0,0,1-3.047-.576,5.2,5.2,0,0,1-3.938,2.359,9.9,9.9,0,0,1-4.161-.353,4.105,4.105,0,0,1-1.858,1.653,7.728,7.728,0,0,1-3.14.557Zm-1.6-15.382a8.025,8.025,0,0,0,.149,3.808,9.382,9.382,0,0,0,5.276,6.874,5.964,5.964,0,0,0-.223-1.3C91.042,414.56,88.255,410.9,87.289,410.491Zm10.348-1.616a26.363,26.363,0,0,0,.316,3.827,9.623,9.623,0,0,0,2.824,5.982,29.2,29.2,0,0,0-3.14-9.809Zm11.685-1.616h0s-.706.353-.966,3.455.279,5.239,1.728,6.484a5.69,5.69,0,0,0,1.115.706,4.161,4.161,0,0,0,1-1.858,11.629,11.629,0,0,0-2.211-8.23c-.39-.483-.613-.557-.669-.557Z",
    transform: "translate(-75.075 -405.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M231.357,432.043l5.034-8.731-5.034-8.731H225.97l3.047,8.731-3.047,8.731Z",
    transform: "translate(54.353 -397.524)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M231.161,426.714a4.552,4.552,0,1,1,0-9.084l-8.546-1.709-2.285,6.911,3.827,5.833Z",
    transform: "translate(49.516 -396.374)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M233.542,414.58H223.454l-5.034,8.731,5.034,8.731h10.088l5.034-8.731Zm-5.034,13.283a4.551,4.551,0,1,1,4.533-4.552,4.552,4.552,0,0,1-4.533,4.552Z",
    transform: "translate(47.877 -397.524)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M419.614,420.247l-3.734-6.484,3.734-6.484h3.994l-2.248,6.484,2.248,6.484Z",
    transform: "translate(217.247 -403.785)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M419.9,416.287a3.381,3.381,0,1,0,0-6.744l6.354-1.263,1.691,5.127-2.824,4.328Z",
    transform: "translate(220.695 -402.927)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M421.326,407.28h7.431l3.715,6.484-3.715,6.484h-7.431l-3.715-6.484Zm3.715,9.865a3.359,3.359,0,1,1,.019,0Z",
    transform: "translate(218.731 -403.785)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M344.836,422.571h8.4a3.976,3.976,0,0,0,3.957-3.976h0a3.976,3.976,0,0,0-3.957-3.976h-8.4a3.976,3.976,0,0,0-3.976,3.976h0a3.976,3.976,0,0,0,3.976,3.976Z",
    transform: "translate(152.899 -397.489)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M336.157,416.843a8.286,8.286,0,1,1,3.716,11.481,8.564,8.564,0,0,1-3.716-11.481Z",
    transform: "translate(148.072 -399.266)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 2.545,
    height: 18.763,
    transform: "translate(488.796 30.141) rotate(-154.76)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404ErrorwithabrokenrobotRafiki);
export default __webpack_public_path__ + "static/media/404 Error with a broken robot-rafiki.54814fe6e25e3ac0cf23551068ae381a.svg";
export { ForwardRef as ReactComponent };